// extracted by mini-css-extract-plugin
export var formContainer = "_ds-0";
export var message = "_ds-1";